import type { ElementProps } from "../../functionalComponents/RenderPage";

function StickyFooter({ atomId, pageIndex }: ElementProps) {
	return <div data-testid={`sticky-footer-${pageIndex}-${atomId}`} />;
}

export default StickyFooter;
